import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

console.log('[main] Starting Angular bootstrap...');
platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => console.log('[main] Bootstrap success'))
  .catch(err => {
    console.error('[main] Bootstrap error:', err);
    document.body.innerHTML = '<div style="padding:20px;color:red;font-family:monospace;"><h2>App Error</h2><pre>' + (err.message || err) + '</pre></div>';
  });



// WEBPACK FOOTER //
// ./src/main.ts